import React from 'react';
import { Divider, List, ListItem, ListItemText } from '@mui/material';
import { useTranslationContext } from 'contexts/TranslationContext/TranslationContext';
import { DeactivateAccount } from './DeactivateAccount';
import { DeleteAccount } from './DeleteAccount';

export const MobileManageAccountContent = () => {
  const { translation } = useTranslationContext();
  return (
    <List component="div" sx={{ padding: 4 }}>
      <ListItem
        id="account__modal-deactivate-account-section"
        aria-label={translation('deactivate_account_header')}
        sx={{ flexDirection: 'column', alignItems: 'start', gap: 1 }}
      >
        <ListItemText
          primary={translation('deactivate_account_header')}
          primaryTypographyProps={{ variant: 'callout' }}
          secondary={translation('deactivate_account_body')}
        />
        <DeactivateAccount />
      </ListItem>
      <Divider sx={{ marginY: 2 }} />
      <ListItem
        id="account__modal-delete-account-section"
        aria-label={translation('delete_account')}
        sx={{ flexDirection: 'column', alignItems: 'start', gap: 1 }}
      >
        <ListItemText
          primary={translation('delete_account')}
          primaryTypographyProps={{ variant: 'callout' }}
          secondary={translation('delete_account_subheader')}
        />
        <DeleteAccount />
      </ListItem>
      <Divider sx={{ marginY: 2 }} />
    </List>
  );
};
